<template>
  <div>
    <div class="container-fluid" style="overflow: auto; padding: 0">
      <div class="table-responsive">
        <table class="table rep_resources_table" id="alertDataList">
          <thead v-bind:class="{ 'disable-content': disableContent }">
            <tr>
              <th style="width: 40px" class="first-col sticky">
                <div
                  class="checkbox top-2"
                  v-if="
                    permissions.includes(
                      'REGULATORY_WATCH_ADMIN_REGULATORY_WATCH_ALERT_SELECT/DELETE'
                    )
                  "
                >
                  <label>
                    <input type="checkbox" v-model="checkAllRegistrations" @change="checkAll()" />
                    <span class="cr"></span>
                  </label>
                </div>
              </th>
              <th
                style="width: 30%"
                @click="sortBy('Title')"
                :class="{ active: sortKey === 'Title' }"
              >
                Title
                <span class="sort sortPosition" :class="sortOrders['Title'] > 0 ? 'asc' : 'desc'">
                </span>
              </th>
              <th @click="sortBy('Country')" :class="{ active: sortKey === 'Country' }">
                Country
                <span class="sort sortPosition" :class="sortOrders['Country'] > 0 ? 'asc' : 'desc'">
                </span>
              </th>
              <th @click="sortBy('Status')" :class="{ active: sortKey === 'Status' }">
                Status
                <span class="sort sortPosition" :class="sortOrders['Status'] > 0 ? 'asc' : 'desc'">
                </span>
              </th>
              <th
                class="text-nowrap"
                @click="sortBy('Published date')"
                :class="{ active: sortKey === 'Published date' }"
              >
                Published date
                <span
                  class="sort sortPosition"
                  :class="sortOrders['Published date'] > 0 ? 'asc' : 'desc'"
                >
                </span>
              </th>
            </tr>
          </thead>
          <tbody ref="tbodyBox">
            <tr
              v-for="(entry, index) in filteredData"
              @click="editRegulatoryAlert(entry)"
              class="cursor-pointer"
              :key="index"
              :class="[{ 'selected-row': activeId === entry.alertId }, statusClass(entry.Status)]"
            >
              <td style="width: 40px" class="first-col sticky">
                <div
                  @click.stop
                  class="checkbox top-2"
                  v-if="
                    permissions.includes(
                      'REGULATORY_WATCH_ADMIN_REGULATORY_WATCH_ALERT_SELECT/DELETE'
                    )
                  "
                >
                  <label>
                    <input
                      type="checkbox"
                      :value="entry"
                      v-model="selectedAlert"
                      @change="checkIsSelectAll"
                    />
                    <span class="cr"></span>
                  </label>
                </div>
              </td>
              <td>
                <div
                  class="alert-description-ellipsis"
                  v-html="$options.filters.highlight(entry['Title'], filterKey)"
                ></div>
              </td>
              <td>
                <span
                  class="flag-icon flag-icon-squared"
                  :class="countryFlag(entry['Country Code'])"
                ></span>
                <span
                  class="pl-10"
                  v-html="$options.filters.highlight(entry['Country'], filterKey)"
                ></span>
              </td>
              <td style="position: relative">
                <span>
                  <span v-html="$options.filters.highlight(entry['Status'], filterKey)"> </span>
                </span>
              </td>
              <td>
                <span
                  v-html="$options.filters.highlight(entry['Published date'], filterKey)"
                ></span>
              </td>
            </tr>
            <!-- <tr
            v-if="filteredData.length==0 && !loadingStatus && !disableContent"
            style="background-color: #f9f9f9;"
          >
            <td :colspan="filteredData.length+1" class="no-records-found">No Records Found</td>
          </tr> -->
          </tbody>
        </table>
        <div
          v-if="filteredData.length == 0 && !loadingStatus && !disableContent"
          class="no-records-found"
        >
          No Records Found
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // components: { DeleteAlertPopup },
  props: {
    permissions: Array,
    data: Array,
    filterKey: String,
    selectedRegistrationList: Array,
    selectedAlertList: Array,
    loadingStatus: Boolean,
    disableContent: Boolean,
    clearSelection: Boolean,
    refreshDataAfterDelete: Boolean,
    isFromGlobalSearch: Boolean
  },
  data() {
    const gridColumns = ['Published date', 'Country', 'Status', 'Title', 'Description'];
    const sortOrders = {};
    gridColumns.forEach((key) => {
      sortOrders[key] = -1;
    });
    return {
      sortKey: 'Published date',
      sortOrders,
      selectedAlert: [],
      selectedRegulatoryAlert: {},
      checkAllRegistrations: false,
      activeId: '',
      tbodyHeight: ''
    };
  },

  created() {
    // We initially sync the internalValue with the value passed in by the parent
    this.selectedAlert = this.selectedAlertList;
  },
  watch: {
    data() {
      this.getBodyHeight();
    },

    selectedAlert() {
      this.$emit('selectedAlertListChanged', this.selectedAlert);
    },

    filteredData() {
      this.$emit('searchResult', this.filteredData.length || 0);
      this.getBodyHeight();
    },

    refreshDataAfterDelete() {
      this.checkAllRegistrations = false;
      this.selectedAlert = [];
    },

    clearSelection() {
      if (this.clearSelection) this.activeId = '';
    }
  },
  computed: {
    filteredData() {
      const { sortKey } = this;
      const filterKey = this.filterKey && this.filterKey.toLowerCase();
      const order = this.sortOrders[sortKey] || -1;
      let { data } = this;
      const gridColumns = ['Published date', 'Country', 'Status', 'Title', 'Description'];
      if (filterKey) {
        const filterSearch = filterKey.split(' ');

        filterSearch.forEach((search) => {
          data = data.filter((row) =>
            Object.keys(row).some((key) => {
              if (gridColumns.indexOf(key) === -1) {
                return false;
              }
              return String(row[key]).toLowerCase().indexOf(search) > -1;
            })
          );
        });
      }
      if (sortKey) {
        data = data.slice().sort((first, second) => {
          const a = first[sortKey];
          const b = second[sortKey];
          if (sortKey === 'Published date') {
            if (order > 0) {
              if (new Date(a).toString() === 'Invalid Date') return 1;
              if (new Date(b).toString() === 'Invalid Date') return -1;
              return new Date(a) - new Date(b);
            }
            if (new Date(a).toString() === 'Invalid Date') return -1;
            if (new Date(b).toString() === 'Invalid Date') return 1;
            return new Date(b) - new Date(a);
          }
          if (a === b) return 0 * order;
          if (a > b) return 1 * order;
          return -1 * order;
        });
      }
      return data;
    }
  },
  filters: {
    highlight(words, filterKey) {
      if (filterKey === '') {
        return words;
      }
      if (words != null) {
        const filterHighlight = filterKey.split(' ');
        const pattern = `(|\\b)(${filterHighlight.join('|')})`;
        const patternString = new RegExp(pattern, 'gi');
        const filteredText = words.replace(patternString, '<span class="highlight">$2</span>');
        return filteredText;
      }
      return '';
    }
  },
  methods: {
    countryFlag(code) {
      return `flag-icon-${code.toLowerCase()}`;
    },

    checkAll() {
      if (this.checkAllRegistrations) {
        this.selectedAlert = [...this.filteredData];
      } else {
        this.selectedAlert = [];
      }
    },

    checkIsSelectAll() {
      this.checkAllRegistrations = this.selectedAlert.length === this.filteredData.length;
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] *= -1;
    },

    formatDescription(record) {
      return record.Description.replace(/<br\s*[\/]?>/gi, '\n'); //eslint-disable-line
    },

    statusClass(status) {
      if (status.toLowerCase() === 'awaiting review') {
        return 'expired';
      }
      if (status.toLowerCase() === 'draft') {
        return 'pending';
      }
      return 'active-status';
    },
    getBodyHeight() {
      this.tbodyHeight = this.$refs.tbodyBox.offsetHeight;
    },
    editRegulatoryAlert(record) {
      this.activeId = record.alertId;
      this.selectedRegulatoryAlert = record;
      this.$emit('regulatoryAlertClicked', this.selectedRegulatoryAlert);
    }
  }
};
</script>
<style scoped>
.mt-5 {
  margin-top: 5px;
}

.table-responsive {
  overflow-y: hidden;
}

.table {
  overflow-x: auto;
  width: 100%;
  margin: -1px;
}

.first-col {
  width: 7%;
}

table td .alert-description-ellipsis {
  white-space: pre-wrap;
}

.rep_resources_table {
  vertical-align: unset;
}

.rep_resources_table tbody tr:last-child {
  border-bottom: 0 !important;
}

tbody tr {
  border-bottom: 0.7px solid #bdbdbd;
}

.rep_resources_table tr th,
.rep_resources_table tr td {
  vertical-align: middle;
}

.rep_resources_table tr > .first-col {
  padding-left: 35px !important;
  z-index: 1;
}

.first-col .first-col-actions {
  display: flex;
}

.rep_resources_table tr > td {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.7);
  padding: 14px !important;
}
.rep_resources_table td a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  padding: 8px 12px;
}

.rep_resources_table td:last-child a {
  padding-right: 15px;
}

.rep_resources_table th {
  font-weight: 500;
  font-size: 14px;
  color: #0b3c61;
  padding: 16px !important;
  border: none;
}

.rep_resources_table thead {
  background: #fff;
  border-bottom: 1px dotted #bdbdbd !important;
}

.rep_resources_table.table > thead:first-child > tr:first-child > th {
  font-weight: 500;
}

.rep_resources_table .cell {
  word-break: break-word;
}

.rep_resources_table .menu-icons {
  width: 16px;
  height: 16px;
  margin-right: 12px;
  margin-left: 6px;
}

.sort {
  padding-left: 8px;
}

.sort.desc:before {
  content: url('/static/images/icons/sortDesc.svg');
}

.sort.asc:before {
  content: url('/static/images/icons/sortDesc.svg');
  display: inline-block;
  transform: rotate(180deg);
  position: relative;
  top: 2px;
}

.sortPosition:before {
  position: relative;
  top: -1px;
}

.no-records-found {
  background-color: #f9f9f9;
}

@media screen and (max-width: 767px) {
  .rep_resources_table tr > .sticky {
    position: sticky;
    left: 0;
    /* background: white; */
  }

  .rep_resources_table tr > .sticky:hover {
    z-index: 2;
  }

  .rep_resources_table tr > .first-col::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: -1;
    /* box-shadow: 3px -1px 4px 0px rgba(0, 0, 0, 0.1); */
  }

  .table-responsive {
    border-top: none;
  }
}
</style>
